/* @flow */

import type { Customer } from "shop-state/types";

import React from "react";
import { Link } from "react-router-dom";
import { useTranslate } from "@awardit/react-use-translate";
import cn from "classnames";
import WarningIcon from "@material-ui/icons/ReportProblemOutlined";

import styles from "./styles.scss";

type Props = {
  className?: string,
  customer: ?Customer,
  to: ?string,
};

export const hasExpiringPoints = (customer: ?Customer): boolean => Boolean(customer &&
  customer.memberPoints &&
  customer.memberPoints.expirePoints &&
  customer.memberPoints.expirePoints.length > 0);

const ExpiringPointsBanner = ({
  className,
  customer,
  to,
}: Props): React$Node => {
  const t = useTranslate();
  const messageStart = `${t("ACCOUNT.POINTS_EXPIRING")} ${t("ACCOUNT.VIEW_ACCOUNT_PREFIX")} `;
  const suffix = t("ACCOUNT.VIEW_ACCOUNT_SUFFIX");
  const messageEnd = suffix ? ` ${suffix}` : "";

  if (!hasExpiringPoints(customer) || !to) {
    return null;
  }

  return (
    <div className={cn(styles.container, "awardit-expiringPointsBanner", className)}>
      <WarningIcon className={styles.icon} />
      <p>
        {messageStart}
        <Link to={to}>
          {t("ACCOUNT.VIEW_ACCOUNT_LINK")}
        </Link>
        {messageEnd}
      </p>
    </div>
  );
};

export default ExpiringPointsBanner;
